import { createReducer, on } from "@ngrx/store";
import * as CompanyActions from "../companies/company-actions";
import { CompanyStateInterface } from "src/app/company/models/companyStateInterface";

export const initialState: CompanyStateInterface = {
    isLoading: false,
    companies: [],
    error: null,
};

export const companyReducers = createReducer(
    initialState, 

    // get Companies
    on(CompanyActions.getCompanies, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(CompanyActions.getCompaniesSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        companies: action.companies.slice().sort((a, b) => a.name.localeCompare(b.name))
    })),
    on(CompanyActions.getCompaniesFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // create Company 
    on(CompanyActions.createCompany, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(CompanyActions.createCompanySuccess, (state, action) => (console.log(action.company),{
        ...state, 
        isLoading: false,
        companies: [...state.companies, action.company].sort((a, b) => a.name.localeCompare(b.name))
    })),
    on(CompanyActions.createCompanyFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // update Company
    on(CompanyActions.updateCompany, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(CompanyActions.updateCompanySuccess, (state, action) => {
        const updatedIndex = state.companies.findIndex(company => company.id === action.company.id);
        
        if (updatedIndex === -1) {
            return state; // If company not found, return current state
        }

        const updated = [...state.companies];
        updated[updatedIndex] = action.company;

        return {
            ...state,
            isLoading: false,
            companies: updated.sort((a, b) => a.name.localeCompare(b.name))
        };
    }),
    on(CompanyActions.updateCompanyFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // delete Company
    on(CompanyActions.deleteCompany, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(CompanyActions.deleteCompanySuccess, (state,action) => ({
        ...state, 
        isLoading: false,
        companies: state.companies.filter(company => company.id !== action.id)
      })),
    on(CompanyActions.deleteCompanyFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),
);